import { ROUTER_BREADCRUMBS_PATHNAMES } from '@/constants/router.constants';
import { BreadcrumbLink } from '@src/features';

export const crumb = (to: string) => ({
  crumb: () => (
    <BreadcrumbLink to={to} name={ROUTER_BREADCRUMBS_PATHNAMES[to] || to} />
  ),
});
